import { render, staticRenderFns } from "./OwnerSettlementCreate.vue?vue&type=template&id=40b58470&scoped=true&lang=pug"
import script from "./OwnerSettlementCreate.vue?vue&type=script&lang=js"
export * from "./OwnerSettlementCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b58470",
  null
  
)

export default component.exports